import * as api from "@/api/client.js";

export type CreateTestTestimonialRequest = {
  id: string;
  code?: string;
  editorialCategoryId: number;
  contentType?: string;
  content: string;
  lawyerName?: string;
  publication: string;
  edition: string;
  publicationId: number;
  companyId?: number;
  firmRef?: number;
  contactId?: string;
};

export type CreateTestTestimonialResponse = {
  message: string;
  id: string;
  note: string;
};

export async function createTestTestimonial(
  data: CreateTestTestimonialRequest,
): Promise<CreateTestTestimonialResponse> {
  return api.post<CreateTestTestimonialResponse>("/v1/content-processor/test/testimonials", data);
}
